var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwiter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.108696 18.4353C0.108696 28.4885 8.25841 36.6382 18.3116 36.6382C28.3648 36.6382 36.5145 28.4885 36.5145 18.4353C36.5145 8.38214 28.3648 0.232422 18.3116 0.232422C8.25841 0.232422 0.108696 8.38214 0.108696 18.4353Z",
    fill: "#212529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.413 12.7468C26.7304 13.0881 26.0478 13.2019 25.2514 13.3156C26.0478 12.8606 26.6167 12.178 26.8442 11.2678C26.1616 11.7229 25.3652 11.9504 24.4551 12.178C23.7725 11.4954 22.7485 11.0403 21.7246 11.0403C19.3355 11.0403 17.5152 13.3156 18.0841 15.591C15.0123 15.4772 12.2819 13.9983 10.3478 11.7229C9.32391 13.4294 9.89275 15.591 11.4855 16.7287C10.9167 16.7287 10.3478 16.5012 9.77898 16.2736C9.77898 17.9801 11.0304 19.5729 12.7369 20.028C12.1681 20.1417 11.5993 20.2555 11.0304 20.1417C11.4855 21.6207 12.8507 22.7584 14.5572 22.7584C13.192 23.7823 11.1442 24.3512 9.21014 24.1236C10.9167 25.1475 12.8507 25.8301 14.8985 25.8301C21.8384 25.8301 25.7065 20.028 25.479 14.6809C26.2754 14.2258 26.958 13.5432 27.413 12.7468Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwiter);
export default __webpack_public_path__ + "static/media/twiter.3cfd566375d28a5299f9cd4fa29f2eaa.svg";
export { ForwardRef as ReactComponent };